module.exports = __webpack_public_path__ + "img/calendar-light.eab693a0.svg";